import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AppProvider } from './context/AppContext';

// Layouts & Pages
import PublicLayout from './components/layouts/PublicLayout';
import AdminLayout from './components/layouts/AdminLayout'; // Import Layout Admin Baru

import HomePage from './pages/HomePage';
import LoginPage from './auth/LoginPage';
import RegisterPage from './auth/RegisterPage';
import DashboardAdmin from './pages/admin/DashboardAdmin'; // Import Dashboard Admin Baru

import ProtectedRoute from './components/auth/ProtectedRoute';
import AddAthlete from './pages/admin/AddAthlete';
import AdminTeam from './pages/admin/AdminTeam';
import AdminWeighIn from './pages/admin/AdminWeighIn';
import AdminMedals from './pages/admin/AdminMedals';
import AdminSettings from './pages/admin/AdminSettings';
import TeamDetail from './pages/admin/TeamDetail';
import ManagerDashboard from './pages/manager/ManagerDashboard';
import ManagerLayout from './components/layouts/ManagerLayout';
import ManagerAddAthlete from './pages/manager/ManagerAddAthlete';
import ManagerAthleteKyorugi from './pages/manager/ManagerAthleteKyorugi';
import ManagerAthletePoomsae from './pages/manager/ManagerAthletePoomsae';
import ManagerPayment from './pages/manager/ManagerPayment';
import ManagerProposal from './pages/manager/ManagerProposal';
import ManagerSettings from './pages/manager/ManagerSettings';
import ManagerProfile from './pages/manager/ManagerProfile';
import AdminPayment from './pages/admin/AdminPayment';
import PublicCheckData from './pages/PublicCheckData';
import InformationPage from './pages/InformationPage';
import AdminUsers from './pages/admin/AdminUsers';
import AdminLiveMonitor from './pages/admin/AdminLiveMonitor';
import AdminPoomsae from './pages/admin/AdminPoomsae';
import AdminKyorugiPrestasi from './pages/admin/AdminKyorugiPrestasi';
import AdminKyorugiFestival from './pages/admin/AdminKyorugiFestival';
import AdminAthleteKyorugi from './pages/admin/AdminAthleteKyorugi';
import AdminAthletePoomsae from './pages/admin/AdminAthletePoomsae';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>

          {/* PUBLIC ROUTES */}
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<HomePage />} />
            <Route path="cek-data" element={<PublicCheckData />} />
            <Route path="informasi" element={<InformationPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="unauthorized" element={<h1 className="text-center mt-5">403 - Akses Ditolak</h1>} />
          </Route>

          {/* MANAGER ROUTES */}
          <Route element={<ProtectedRoute allowedRoles={['manager']} />}>
            <Route path="/manager" element={<ManagerLayout />}>
              <Route path="dashboard" element={<ManagerDashboard />} />

              {/* Rute Dinamis Atlet (Kyorugi/Poomsae & Prestasi/Festival) */}
              <Route path="atlet/kyorugi/:type" element={<ManagerAthleteKyorugi />} />
              <Route path="atlet/poomsae/:type" element={<ManagerAthletePoomsae />} />
              <Route path="atlet" element={<Navigate to="/manager/atlet/kyorugi/prestasi" replace />} />
              <Route path="atlet/tambah" element={<ManagerAddAthlete />} />
              <Route path="atlet/edit/:uuid" element={<ManagerAddAthlete />} />

              {/* Rute Dinamis Live Monitor Manager */}
              <Route path="live-paparan/prestasi" element={<AdminLiveMonitor type="Prestasi" />} />
              <Route path="live-paparan/festival" element={<AdminLiveMonitor type="Festival" />} />

              <Route path="pembayaran" element={<ManagerPayment />} />
              <Route path="proposal" element={<ManagerProposal />} />
              <Route path="settings" element={<ManagerSettings />} />
              <Route path="profile" element={<ManagerProfile />} />
            </Route>
          </Route>

          {/* ADMIN ROUTES */}
          <Route element={<ProtectedRoute allowedRoles={['super_admin', 'admin_timbang', 'admin_medali', 'admin_koordinator']} />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route path="dashboard" element={<DashboardAdmin />} />
              <Route path="pembayaran" element={<AdminPayment />} />

              {/* Rute Dinamis Atlet (Kyorugi/Poomsae & Prestasi/Festival) */}
              <Route path="atlet/kyorugi/:type" element={<AdminAthleteKyorugi />} />
              <Route path="atlet/poomsae/:type" element={<AdminAthletePoomsae />} />
              <Route path="atlet" element={<Navigate to="/admin/atlet/kyorugi/prestasi" replace />} />
              <Route path="atlet/tambah" element={<AddAthlete />} />
              <Route path="atlet/edit/:uuid" element={<AddAthlete />} />

              <Route path="tim" element={<AdminTeam />} />
              <Route path="tim/:id" element={<TeamDetail />} />

              {/* Rute Penimbangan */}
              <Route path="timbang/prestasi" element={<AdminWeighIn type="Prestasi" />} />
              <Route path="timbang/festival" element={<AdminWeighIn type="Festival" />} />
              <Route path="timbang" element={<Navigate to="/admin/timbang/prestasi" replace />} />

              {/* Rute Bagan Pertandingan */}
              <Route path="bagan/prestasi" element={<AdminKyorugiPrestasi type="Prestasi" />} />
              <Route path="bagan/festival" element={<AdminKyorugiFestival type="Festival" />} />
              <Route path="bagan" element={<Navigate to="/admin/bagan/prestasi" replace />} />

              {/* Rute Live Monitor Admin */}
              <Route path="live-paparan/prestasi" element={<AdminLiveMonitor type="Prestasi" />} />
              <Route path="live-paparan/festival" element={<AdminLiveMonitor type="Festival" />} />

              {/* Rute Penilaian Poomsae */}
              <Route path="poomsae/prestasi" element={<AdminPoomsae type="Prestasi" />} />
              <Route path="poomsae/festival" element={<AdminPoomsae type="Festival" />} />

              {/* Rute Medali & Juara */}
              <Route path="medali" element={<AdminMedals />} />
              <Route path="profile" element={<ManagerProfile />} />


              <Route path="settings" element={<AdminSettings />} />
              <Route path="users" element={<AdminUsers />} />
            </Route>
          </Route>

        </Routes>

        <ToastContainer position="bottom-right" theme="colored" autoClose={3000} />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
